import React from 'react';

import NewSale from 'components/Tvendo/Sale/Operations/NewSale/NewSale.js';

export default function () {
  return <NewSale />;
}
